const PARENT = 'MARKETING_BLAST_'

export const DEFAULT_FILTERS_STATE = {
  sort: "created_at",
  direction: "desc",
  search: "",
  filter: {},
  page: 1,
  rpp: 10
}

const DEFAULT_STATE = {
  filters: {
    "sort": "created_at",
    "direction": "desc",
    "search": "",
    "filter": {},
    "page": 1,
    "rpp": 10
  }
}

export default function filterReducer(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case `${PARENT}FILTER_CHANGE`:
      return { ...state, ...action.filters };
    case `${PARENT}FILTER_RESET`:
      return { ...state, ...DEFAULT_STATE };
    default:
      return state;
  }
}
